import { useTranslation } from 'next-i18next/pages';
import React from 'react';

type TransCompProps = {
  i18nKey: string;
  values?: any;
  customComponent?: keyof React.JSX.IntrinsicElements;
  className?: string;
};

/** 표시 제어 클래스는 globals.css 의 .trans-custom 아래에 있다 */
export default function TransCustom({
  i18nKey,
  values = undefined,
  customComponent,
  className,
}: TransCompProps) {
  const { t } = useTranslation('common');
  const Component = customComponent || 'span';
  const text = t(i18nKey, values).toString();

  return (
    <span className={`trans-custom ${className ?? ''}`}>
      <Component
        dangerouslySetInnerHTML={{
          __html: text,
        }}
      />
    </span>
  );
}
